import React, { Component, ErrorInfo, ReactNode } from 'react';
import { reloadOnceForChunkErrorInBrowser } from '../utils/chunkLoadRecovery';

type Props = {
    children: ReactNode;
};
type State = {
    hasError: boolean;
    error: Error | null;
    errorInfo: ErrorInfo | null;
};

class ErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null
        };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        // A chunk the deploy already removed: the page reloads onto the new build, once.
        if (reloadOnceForChunkErrorInBrowser(error)) return;

        // Log error information
        console.error('Caught by ErrorBoundary:', error);
        console.error('Component Stack:', errorInfo?.componentStack);

        setTimeout(() => {
            throw error;
        });
    }

    render() {
        if (this.state.hasError) {
            return <div style={{ height: 500, fontSize: 20, lineHeight: '500px', textAlign: 'center' }}>processing...</div>;
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
